module.exports = __webpack_public_path__ + "img/succ-bg4.b21e3f79.png";